export default __webpack_public_path__ + "static/media/Biogaz.f8a5b42a.jpg";